import type { JobLogEntry } from "./parseJobLogEvent";

export type LogMarkerKey = "Iteration" | "Room" | "Scenario";

const markerPattern = (key: LogMarkerKey) => new RegExp(`${key}=([^|]+)\\|\\|`, "i");

export const extractLogMarker = (message: string, key: LogMarkerKey): string | undefined => {
  const match = markerPattern(key).exec(message);
  const value = match?.[1]?.trim();
  return value || undefined;
};

const compareLogMarkers = (left: string, right: string) => {
  const leftNumber = Number(left);
  const rightNumber = Number(right);
  if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) return leftNumber - rightNumber;
  return left.localeCompare(right);
};

export const collectLogMarkers = (lines: readonly JobLogEntry[], key: LogMarkerKey): string[] => {
  const values = new Set<string>();
  lines.forEach((line) => {
    const value = extractLogMarker(line.message, key);
    if (value) values.add(value);
  });
  return [...values].sort(compareLogMarkers);
};

export const isLogVisibleForMarker = (
  message: string,
  key: LogMarkerKey,
  selectedValues: ReadonlySet<string>
): boolean => {
  if (selectedValues.size === 0) return true;
  const value = extractLogMarker(message, key);
  return value == null || selectedValues.has(value);
};
